var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    { ref: "dialog", attrs: { closable: "", title: "Delete stream?" } },
    [
      _c("p", [
        _vm._v("You are about to delete the stream "),
        _c("strong", [_vm._v(_vm._s(_vm.streamTitle))]),
        _vm._v(", please confirm."),
      ]),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          _c("ui-button", {
            attrs: { text: "Cancel", tooltip: "Abort deletion" },
            on: {
              click: function ($event) {
                return _vm.$refs.dialog.close()
              },
            },
          }),
          _vm._v(" "),
          _c("ui-button", {
            attrs: {
              disabled: _vm.isFetching,
              secondary: "",
              text: "Delete",
              tooltip: "Delete stream",
            },
            on: { click: _vm.deleteStream },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }